import React, { useState } from "react";
import { Link } from "react-router-dom";

import faqImg from "../assets/images/app/app chat.png";

import { FiChevronUp } from "react-icons/fi";

import { faq } from "../data/data";

interface FaqData {
  id: number;
  title: string;
  desc: string;
}

export default function Faq() {
  let [activeTab, setActiveTab] = useState<number>(1);

  return (
    <div className="container relative">
      <div className="grid md:grid-cols-2 grid-cols-1 items-center gap-[30px]">
        <div className="relative order-1 md:order-2">
          <div className="relative">
            <img
              src={faqImg}
              className="mx-auto w-40 lg:w-64 h-auto"
              alt=""
            />
          </div>
          <div className="overflow-hidden absolute md:size-[500px] size-[400px] bg-gradient-to-tr to-red-500/20 via-red-500/70 from-red-500 bottom-1/2 translate-y-1/2 md:end-0 end-1/2 md:translate-x-0 translate-x-1/2 -z-1 shadow-md shadow-red-500/10 rounded-full"></div>
        </div>

        <div className="lg:me-8 order-2 md:order-1">
          <h6 className="text-red-500 uppercase text-sm font-bold tracking-wider mb-3">
            Preguntas frecuentes
          </h6>
          <h4 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-bold">
            ¿Tienes dudas? Revisa aquí
          </h4>
          <p className="text-slate-400 max-w-xl mx-auto">
            Resolvemos lo más importante sobre el uso de Therapy Connect y el
            acceso a la demo.
          </p>

          <div id="accordion-collapseone" className="mt-8">
            {faq.map((item: FaqData, index: number) => {
              return (
                <div
                  className={`relative shadow dark:shadow-gray-800 rounded-md overflow-hidden ${item.id !== 1 ? "mt-3" : ""}`}
                  key={index}
                >
                  <h2 className="font-semibold">
                    <button
                      type="button"
                      onClick={() => setActiveTab(item.id)}
                      className={`flex justify-between items-center p-5 w-full font-medium text-start ${activeTab === item.id ? "bg-slate-50/50 dark:bg-slate-800/20 text-red-500" : ""}`}
                    >
                      <span>{item.title}</span>
                      <FiChevronUp
                        className={`size-4 shrink-0 ${activeTab === item.id ? "" : "rotate-180"}`}
                      />
                    </button>
                  </h2>
                  <div className={`${activeTab === item.id ? "" : "hidden"}`}>
                    <div className="p-5">
                      <p className="text-slate-400 dark:text-gray-400">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="mt-6">
            <Link
              to="#"
              className="hover:text-red-500 dark:hover:text-red-500 after:bg-red-500 dark:text-white transition duration-500 font-medium"
            >
              Ver más <i className="mdi mdi-arrow-right"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
